import e500 from "./assets/images/no-wifi.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


export default function NoInternet(){
    const { t, i18n } = useTranslation();

    return (
        <div style={{textAlign: "center", marginTop: "30vh", color: "#999", padding: "0 30px"}}>
            <img 
                src={e500}
                alt="404 error"
                style={{
                    width: "50vw"
                }}
            />
            <br />
            <br />
            {t('NoInternet.label')}
            <br />
            {t('PleaseInternet.label')}
            <br />
            <br />
            <Link to="/" className="primary-btn">{t('return.label')}</Link>
        </div>
    )
}